<template>
    <div>
        <v-row
                v-show="show"
                dense
                class="text-center">
            <v-col
                    cols="12"
                    md="6"
                    dense
                    class="text-center">
                <v-text-field
                        v-model="cardNumberInput"
                        v-mask="'#### #### #### ####'"
                        autocomplete="cc-number"
                        x-autocompletetype="cc-number"
                        hint="Example: 1234 1234 1234 1234"
                        label="Card Number"
                        append-icon="mdi-credit-card"
                        outlined
                        @input="resetState" />
            </v-col>
            <v-col
                    cols="6"
                    md="3"
                    dense
                    class="text-center">
                <v-text-field
                        v-model="cardExpirationInput"
                        v-mask="'##/##'"
                        label="MM/YY"
                        outlined
                        @input="resetState" />
            </v-col>
            <v-col
                    cols="6"
                    md="3"
                    dense
                    class="text-center">
                <v-text-field
                        v-model="cardSecurityCodeInput"
                        v-mask="'###'"
                        label="CVV/CVC"
                        type="password"
                        outlined
                        @input="resetState" />
            </v-col>
        </v-row>
        <v-dialog
                v-model="openPopup3ds"
                persistent
                scrollable
                fullscreen>
            <div style="background-color: white;">
                <iframe
                        width="100%"
                        height="100%"
                        :src="popup3dsSrc" />
            </div>
        </v-dialog>
    </div>
</template>

<script>
    import PaymentTypeModel from "@/models/paymenttype.model";
    import Customer from "@/models/customer.model";

    export default {
        name: "SageMethodComponent",
        props: {
            show: {type: Boolean, default: true},
            config: {type: Object, required: true},
            threeDs: {type: Object, required: true},
            title: {type: String, default: 'Add new payment card'},
            consumer: {type: Customer, required: true }
        },
        data() {
            return {
                cardNumberInput: null,
                cardExpirationInput: null,
                cardSecurityCodeInput: null,
                card: {
                    number: null,
                    exp: {
                        year: null,
                        month: null,
                    },
                    cvc: null,
                    isValid: false,
                },
                tokenisedRequest: null,
                initRes: null,
                startRes: null,
                checkRes: null,
                stripe: null,
                elements: null,
                loading: false,
                openPopup3ds: false,
                popup3dsSrc: null,
                value: false,
                finished: false,
            }
        },
        computed: {
            account() {
                return this.$store.forms.getAccount();
            },
            appointment() {
                return this.$store.forms.getAppointment();
            },
            isEmpty() {
                return !this.cardNumberInput
                    && !this.cardExpirationInput
                    && !this.cardSecurityCodeInput;
            }
        },
        watch: {
            loading(value) {
                this.$emit('loading', value)
            },
            show(val) {
                if (val === true) {
                    this.initElement();
                }
            }
        },
        mounted() {
            this.initElement()
        },
        methods: {
            isValidCard: function () {
                return !!(this.card.number
                    && this.card.exp.month
                    && this.card.exp.year
                    && this.card.cvc);
            },
            fatalErrorAlert() {
                this.$services.modals.alerts.error('Oops! There seems to be an error with internet connection. Please check that you are online and try again.');
                this.loading = false;
                this.finished = true;
                this.$emit('error');
            },
            showErrorAlert() {
                this.$services.modals.alerts.error('Oops! There seems to be an error with your card details. Please check the information you\'ve entered and try again.');
                this.loading = false;
                this.initElement();
            },
            handleCardNumberInput() {
                this.card.number = this.cardNumberInput.replace(/[^0-9]/gi, '');
                this.card.number = (this.card.number.length > 12) ? this.card.number : null;
            },
            handleCardExpirationInput() {
                this.card.exp.month = this.cardExpirationInput.split('/');

                this.card.exp.year = this.card.exp.month[1] || '';
                this.card.exp.month = this.card.exp.month[0] || '';

                this.card.exp.month = this.card.exp.month.replace(/[^0-9]/gi, '');
                this.card.exp.month = (this.card.exp.month && (this.card.exp.month > 0 && this.card.exp.month < 13)) ? this.card.exp.month : null;
                this.card.exp.year = this.card.exp.year.replace(/[^0-9]/gi, '');
                this.card.exp.year = this.card.exp.year ? this.card.exp.year : null;
            },
            handleCardSecurityCodeInput() {
                this.card.cvc = this.cardSecurityCodeInput.replace(/[^0-9]/gi, '');
                this.card.cvc = (this.card.cvc.length > 2 && this.card.cvc.length < 5) ? this.card.cvc : null;
            },
            handleInput() {
                try {
                    this.handleCardNumberInput()
                    this.handleCardExpirationInput()
                    this.handleCardSecurityCodeInput()

                    this.card.isValid = this.isValidCard();
                    if (!this.card.isValid) {
                        this.showErrorAlert();
                    }
                } catch (e) {
                    this.showErrorAlert();
                }
            },
            tokeniseCardAndStart() {
                sagepayOwnForm({merchantSessionKey: this.initRes.token})
                    .tokeniseCardDetails({
                        cardDetails: {
                            cardholderName: this.consumer.fullName,
                            cardNumber: this.card.number,
                            expiryDate: (this.card.exp.month.length < 2 ? '0' : '') + this.card.exp.month + this.card.exp.year,
                            securityCode: this.card.cvc,
                        },
                        onTokenised: this.onTokenise
                    },);
            },
            async onTokenise(card) {
                if (card.success) {
                    this.tokenisedRequest = Object.assign({}, this.initRes, {
                        card: card.cardIdentifier,
                        brand: card.cardType,
                        last4: this.card.number.slice(-4),
                        expiry: (this.card.exp.month.length < 2 ? '0' : '') + this.card.exp.month + this.card.exp.year,
                    });
                    await this.start3ds()
                } else {
                    this.showErrorAlert();
                    this.initElement();
                }
            },
            resetState() {
                this.value = false;
                this.$emit('init');
            },
            async initElement() {
                this.finished = false;
                this.loading = true;
                this.resetState();
                await this.init3ds()
                this.loading = false;
            },
            async loadSage() {
              if (this.appointment && Array.isArray(this.appointment.payment_types)) {
                const paymentType = this.appointment.payment_types.find(p => p.type === 'sage');
                if (paymentType && paymentType.config) {
                  const baseURL = paymentType.config.base_url + 'js/sagepay.js';
                  var head = document.getElementsByTagName('head')[0];
                  var script = document.createElement('script');
                  script.type = 'text/javascript';
                  script.src = baseURL;
                  head.appendChild(script);
                } else {
                  console.error('Payment type or config not found');
                }
              } else {
                console.error('Appointment or payment_types array not found');
              }
            },
            async init3ds() {
                const res = await this.$services.core.post('3ds/init', {
                    request: this.appointment.id,
                    account: this.appointment.account_id,
                    calendar: this.appointment.calendar_id,
                    first_name: this.consumer.first_name,
                    last_name: this.consumer.last_name,
                    email: this.consumer.email,
                    phone: this.consumer.phone,
                }, {
                    baseURL: this.threeDs.endpoint
                })

                if (res.data.success) {
                    await this.loadSage();
                    this.initRes = res.data;
                } else {
                    this.fatalErrorAlert();
                }
            },
            async start3ds() {
                const res = await this.$services.core.post('3ds/start', this.tokenisedRequest, {
                    baseURL: this.threeDs.endpoint
                })
                this.startRes = res.data;
                if (res.data.success) {
                    if (res.data.popup) {
                        this.popup3dsSrc = this.threeDs.endpoint + '3ds/popup/' + res.data.id;
                        this.openPopup3ds = true;
                        await this.check3ds();
                    } else {
                        await this.finish3ds();
                    }
                } else {
                    this.showErrorAlert()
                }
            },
            async check3ds() {
                try {
                    const res = await this.$services.core.post('3ds/check', this.startRes, {
                        baseURL: this.threeDs.endpoint
                    });
                    this.checkRes = res.data;
                    if (res.data.success && res.data.complete) {
                        this.openPopup3ds = false;
                        await this.finish3ds()
                    } else {
                        setTimeout(this.check3ds, 300);
                    }
                } catch (error) {
                    setTimeout(this.check3ds, 300);
                }
            },
            async finish3ds() {
                try {
                    const res = await this.$services.core.post('3ds/finish', this.checkRes, {
                        baseURL: this.threeDs.endpoint
                    });
                    if (res.data.success) {
                        this.value = new PaymentTypeModel({
                            type: 'sage',
                            name: res.data.details.brand + ' ' + res.data.details.last4,
                            token: res.data.token,
                            brand: res.data.details.brand,
                            last4: res.data.details.last4,
                            exp: {
                                year: res.data.details.expire_year,
                                month: res.data.details.expire_month,
                            }
                        });
                        this.finished = true;
                    } else {
                        this.showErrorAlert()
                    }
                } catch (e) {
                    this.showErrorAlert()
                }
            },
            async awaitFinish() {
                while (!this.finished) {
                    await new Promise(resolve => {
                        setTimeout(function () {
                            resolve();
                        }, 300)
                    })
                }
            },
            async submit() {
                this.loading = true;
                if (!this.isEmpty) {
                    this.handleInput()
                    this.tokeniseCardAndStart()
                    await this.awaitFinish();
                    this.loading = false;
                    return this.value;
                } else {
                    this.$services.modals.alerts.error('Invalid card details');
                    this.loading = false;
                }
                return null;
            }

        }
    }
</script>
<style>
.question-payment-method-item {
  border: solid 1px rgba(0, 0, 0, 0.12);
  padding: 14px 7px;
}

.question-payment-method-item label {
  display: block !important;
}
</style>